import React, { Fragment, useEffect, useState } from 'react';
import { NotificationInline } from 'components/notifications';
import { ManualEntryService } from 'services';
import { FormSelect } from 'components/form-fields';
import { ListingTable } from 'components/listing';

export function ManualEntryTemplateTemplate({
    templateType,
    template,
    options,
    infringements
}) {

    const statutoryTableHeaders = ["Weekday", "Rest Days"];
    const daysOfWeek = [
        { id: 1, name: "Monday" },
        { id: 2, name: "Tuesday" },
        { id: 3, name: "Wednesday" },
        { id: 4, name: "Thursday" },
        { id: 5, name: "Friday" },
        { id: 6, name: "Saturday" },
        { id: 7, name: "Sunday" }
    ];

    const singleDayTableHeaders = ["Activity Type", "Start Time", "End Time", "Duration"];

    const [statutoryTableRows, setStatutoryTableRows] = useState([]);
    const [totalStatutoryRecords, setTotalStatutoryRecords] = useState(0);

    const [singleDayTableRows, setSingleDayTableRows] = useState([]);
    const [totalSingleDayRecords, setTotalSingleDayRecords] = useState(0);

    useEffect(() => {
        mapStatutoryDaysTableData();
    }, [template?.dayNumbers]);

    useEffect(() => {
        mapSingleDayTableData();
    }, [template?.activities]);

    function mapSingleDayTableData() {
        if (templateType !== "MANUALENTRYSINGLE") return;

        const newUserTableRows = mapActivitiesTableData(template?.activities);
        setSingleDayTableRows(newUserTableRows);
        setTotalSingleDayRecords(newUserTableRows.length);
    }

    function mapActivitiesTableData(activities)
    {
        if (!activities || activities.length === 0) return [];

        return activities.map((activity) => {
            const type = options?.activityTypes?.find(t => t.key === activity.type);
            const startTime = ManualEntryService.timeStringToNumeric(activity.time);
            const endTime = startTime + activity.duration;
            const endTimeString = ManualEntryService.timeToString(endTime);
            const durationTime = ManualEntryService.timeToString(activity.duration);

            return [
                type?.name,
                activity.time,
                endTimeString,
                durationTime
            ]
        });
    }
    
    function mapStatutoryDaysTableData() {
        if (templateType !== "STATWEEKHOLIDAY" && templateType !== "STATWEEKSICKNESS") return;

        const newUserTableRows = template?.dayNumbers?.map((day, i) => {
            return [
                daysOfWeek.find(d => d.id === day)?.name,
                `Rest day ${i + 1}`
            ]
        }) ?? [];

        setStatutoryTableRows(newUserTableRows);
        setTotalStatutoryRecords(newUserTableRows.length);
    }

    function renderActivities(id, records, totalRecords, recordsLoading)
    {
        return (
            <ListingTable
                id={id}
                headers={singleDayTableHeaders}
                data={records}
                totalRecordCount={totalRecords}
                noDataMessage={"No activities added"}
                showPerPage={false}
                loadingData={recordsLoading}
                shrinkLastColumn
                pageable={false}
                columnWidths={['25%', '25%', '25%', '25%']}
            />
        );
    }

    function renderMultiDayActivities(day)
    {
        const daysInWeek = 7;
        const daysShift = daysInWeek - daysOfWeek[0].id;
        const weekNumber = Math.floor((day.dayNumber + daysShift) / daysInWeek);
        const id = `listing-table-multi-day-${day.dayNumber}`;
        const dayName = daysOfWeek.find(d => d.id === ((day.dayNumber - 1) % daysInWeek + 1))?.name
        const dayRows = mapActivitiesTableData(day.shifts.flat());

        return (
            <div key={`day-${day.dayNumber}`} className="spacer-bottom">
                <h3>{`Week ${weekNumber} - ${dayName}`}</h3>
                {renderActivities(id, dayRows, dayRows.length, dayRows.length === 0)}
            </div>
        );
    }

    function renderMultiDays() {
        if (templateType !== "MANUALENTRYMULTI") return null;

        return (
            <>
                {template?.days?.map(renderMultiDayActivities)}
            </>
        );
   }

    return (
        <>
            <NotificationInline
                key="view-infringements"
                show={infringements && infringements?.length > 0}
                text={(
                    <>
                        This template will generate the following infringements if applied: {ManualEntryService.groupInfringementCodes(infringements)}
                    </>
                )}
                intent='danger'
                allowClose={false}
            />

            {templateType === "MANUALENTRYSINGLE" && renderActivities("listing-table-single-day", singleDayTableRows, totalSingleDayRecords, totalSingleDayRecords === 0)}
            {templateType === "MANUALENTRYMULTI" && renderMultiDays()}
            {(templateType === "STATWEEKHOLIDAY" || templateType === "STATWEEKSICKNESS") && (
                <Fragment>
                    <FormSelect
                        id="statutory-day-type"
                        headingText="Non-rest day type"
                        items={[{id: 0, name: "Holiday"}, {id: 1, name: "Sickness"}]}
                        onItemSelect={() => {}}
                        selectedValue={templateType === "STATWEEKHOLIDAY" ? 0 : 1}
                        disabled
                    />
                    <ListingTable
                        id="listing-table-statutory"
                        headers={statutoryTableHeaders}
                        data={statutoryTableRows}
                        totalRecordCount={totalStatutoryRecords}
                        noDataMessage={"No days selected"}
                        showPerPage={false}
                        loadingData={totalStatutoryRecords === 0}
                        shrinkLastColumn
                        pageable={false}
                    />
                </Fragment>
            )}
        </>
    );
}
